import { useMemo } from 'react';
import { Col, Input, Row } from 'reactstrap';

import Select from '@/library/components/form/inputs/select';

import { SETTINGS_CATEGORIES } from './constants';
import { useCompanySettingsDraft } from './draft-context';

type CategoryFilterOption = {
  label: string;
  value: string;
};

const CATEGORY_FILTER_OPTIONS: CategoryFilterOption[] = [
  { label: 'All settings', value: 'all' },
  ...SETTINGS_CATEGORIES.map(category => ({
    label: category.title,
    value: category.id
  }))
];

const SettingsFilters = () => {
  const { categoryFilter, searchQuery, setCategoryFilter, setSearchQuery } =
    useCompanySettingsDraft();

  const selectedCategoryOption = useMemo(
    () =>
      CATEGORY_FILTER_OPTIONS.find(option => option.value === categoryFilter) ??
      CATEGORY_FILTER_OPTIONS[0],
    [categoryFilter]
  );

  return (
    <Row className="align-items-center justify-content-between gx-2 mt-4 mb-2">
      <Col xs={4}>
        <Select<CategoryFilterOption>
          className="mb-0"
          options={CATEGORY_FILTER_OPTIONS}
          value={selectedCategoryOption}
          onChange={(option: CategoryFilterOption | null) => {
            setCategoryFilter(option?.value ?? 'all');
          }}
          isClearable={false}
        />
      </Col>
      <Col xs={3}>
        <Input
          type="search"
          bsSize="sm"
          className="mb-0"
          placeholder="Search settings, fields or values..."
          value={searchQuery}
          onChange={event => setSearchQuery(event.target.value)}
        />
      </Col>
    </Row>
  );
};

export default SettingsFilters;
